/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Promise_3_DetailInputs */

const en_cap_promise_3_detail = /** @type {(inputs: Cap_Promise_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What it did, with what, and why.`)
};

const lv_cap_promise_3_detail = /** @type {(inputs: Cap_Promise_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko tā darīja, ar ko un kāpēc.`)
};

/**
* | output |
* | --- |
* | "What it did, with what, and why." |
*
* @param {Cap_Promise_3_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_promise_3_detail = /** @type {((inputs?: Cap_Promise_3_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Promise_3_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_promise_3_detail(inputs)
	return en_cap_promise_3_detail(inputs)
});